import type { ReactNode } from 'react';

export const symbol_file_upload_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M510-684v148l-60-60v-88l-44 44-43-43 96-96q5-5 10-7t11-2q6 0 11 2t10 7l151 151q9 9 9 21t-9 21q-9 9-21.5 9t-21.5-9l-99-98Zm-60 174 60 60v107q0 13-8.5 21.5T480-313q-13 0-21.5-8.5T450-343v-167Zm264 350H220q-24 0-42-18t-18-42v-113q0-13 8.5-21.5T190-363q13 0 21.5 8.5T220-333v113h434L82-792q-9-9-9-21.5t9-21.5q9-9 21.5-9t21.5 9l710 710q9 9 9 21t-9 21q-9 9-21.5 9T792-83l-78-77Zm86-82-60-60v-31q0-13 8.5-21.5T770-363q13 0 21.5 8.5T800-333v91Z"
		/>
	</svg>
);
